<template>
    <v-card height='100%'>
      <v-container fluid class="pa-5">
        <v-row>
          <v-col cols="12">
            <p>{{stock.toUpperCase()}} <span id='performance'></span>Performance - Breakdown by Factors</p>
            <PerformanceBreakdownChart
              :id="stock"
              :apiEndpoint="'/get-stock-return-breakdown/'"
              date-key="date"
              :bar-keys="[
                'Country',
                'Market',
                'Mom',
                'Quality',
                'Residuals',
                'Risk',
                'Sector',
                'Size',
                'Value'
              ]"
              line-key="Return"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card>
</template>

<script>
  import PerformanceBreakdownChart from "@/components/PerformanceBreakdownChart";
  export default {
    name: 'StockAnalyzeComponentChartPerformance',
    props:['stock'],
    components: {
      PerformanceBreakdownChart
    },    
  }
</script>
